import { KLineData } from "klinecharts";
import { klineLineStyle, lineStyleToKLine } from "./lineStyle";
import { getPriceValue, readStyle } from "./indicatorUtils";

export const createMomentum = (settings: any) => {
  const values = settings?.values ?? {};
  const styles = settings?.styles ?? settings?.styleSettings ?? {};
  const period = (values.Period as number) ?? 14;
  const applyTo = (values["Apply to"] as string) ?? "Close";
  const momS = readStyle(styles, "momentum", "#2196F3");

  return {
    name: "momentum",
    shortName: `Mom${period}`,
    calcParams: [period, applyTo],
    series: "normal" as const,
    figures: [{ key: "momentum", title: `Mom${period}: `, type: "line" }],
    styles: {
      lines: [klineLineStyle(momS.color, 2, lineStyleToKLine(momS.style))],
    },
    regenerateFigures: ([p]: number[]) => [
      { key: "momentum", title: `Mom${p}: `, type: "line" },
    ],
    calc: (dataList: KLineData[], indicator: { calcParams?: unknown[] }) => {
      const [p, priceField] = (indicator.calcParams ?? [period, applyTo]) as [
        number,
        string,
      ];
      const n = dataList.length;
      const results: Array<{ momentum?: number }> = new Array(n);
      const buf: number[] = new Array(p);

      for (let i = 0; i < n; i++) {
        const price = getPriceValue(dataList[i]!, priceField);
        const idx = i % p;
        // Read the price from p bars ago before overwriting its slot
        const past = buf[idx]!;
        buf[idx] = price;
        if (i < p) {
          results[i] = {};
        } else {
          // MT4/MT5 convention: Momentum = (price / price[p]) * 100
          results[i] = past === 0 ? {} : { momentum: (price / past) * 100 };
        }
      }

      return results;
    },
  };
};
